import {createAction, createAsyncThunk} from '@reduxjs/toolkit'
import app from '../../data/base';
import {toast} from "react-toastify";

const fetchSessionById = createAsyncThunk('session/fetchById', async (id) => {
  try {
    const token = localStorage.getItem('session_token');
    const path = token ? 'api/session/' : 'api/public/session/'
    const response = await app.methods.callserver(path + id, 'GET', false, null);
    console.log('Session', response);
    const body = await response.json();
    return body
  } catch (e) {
    console.error("fetchSessionById error: ", e);
    toast.error('Impossibile recuperare la sessione');
    throw e;
  }
})
const reset = createAction('session/reset');

export const SessionActions = {
  fetchSessionById,
  reset
}
